import $ from 'jquery'
import '../bem'

// import './cookie-consent'
import BlockFactory from './block-factory'
import lazyBlocks from './lazy-blocks'

const initialize = (instance, elements) => {
	elements.each(function (index) {
		if (typeof $(this).attr('data-no-js') === 'undefined') {
			BlockFactory.create(instance, $(this), index === 0)
		}
	})
}

export default (blocks, context = $('body')) => {
	/**
	 * Dit stuk geeft een melding wanneer de environment nog op development staat
	 * Dit hoeft niet weggehaald te worden als gecompiled wordt als productie,
	 * hier zorgt de compiler voor.
	 */
	if (process.env.NODE_ENV === 'development') {
		// eslint-disable-next-line no-console
		console.log(
			'%cdevelopment build',
			'font-size:2em;width:100%;color:#A3303D;padding:0 1em;',
		)
	}

	/**
	 * Initiate thumb script
	 */
	// thumb()

	Object.keys(blocks).forEach((block) => {
		initialize(blocks[block], context.find(`.${blocks[block].title}`))
	})

	lazyBlocks.forEach(({ title, load }) => {
		const elements = context.find(`.${title}`)

		if (elements.length === 0) {
			return
		}

		load()
			.then(({ default: instance }) => initialize(instance, elements))
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error(`run: failed to load the "${title}" block`, error)
			})
	})
}
